import { createSelector } from '@ngrx/store'

export const getAuditLogsState = createSelector(
  (state: any) => state.auditLogs,
  (state: any) => state.get('list'),
)

export const getAuditLogInfoState = createSelector(
  (state: any) => state.auditLogs,
  (state: any) => state.get('info'),
)

export const isAuditLogsExportingState = createSelector(
  (state: any) => state.auditLogs,
  (state: any) => state.getIn(['export', 'isLoading']),
)
